// // // Projects — horizontal scroll driven by vertical scroll (GSAP pin + scrub)
// // // Works on BOTH desktop and mobile — MobilePanel vertical stack removed.
// // import { useEffect, useRef, useState } from 'react';
// // import { gsap } from 'gsap';
// // import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // import { Label } from './utils';
// // import { fetchProjects } from './data';

// // gsap.registerPlugin(ScrollTrigger);

// // // Height of the top header strip — panels sit strictly below this
// // const HEADER_H = 120; // px

// // /* ─── Progress rail at bottom ──────────────────────────────────── */
// // function ProgressRail({ count, activeIndex }) {
// //   return (
// //     <div style={{
// //       position: 'absolute',
// //       bottom: '2rem',
// //       left: '7vw',
// //       right: '7vw',
// //       zIndex: 30,
// //       display: 'flex',
// //       gap: '6px',
// //       alignItems: 'center',
// //       pointerEvents: 'none',
// //     }}>
// //       {Array.from({ length: count }).map((_, i) => (
// //         <div key={i} style={{
// //           flex: i === activeIndex ? 4 : 1,
// //           height: '1px',
// //           background: i === activeIndex ? 'var(--acid, #d4f700)' : '#222',
// //           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
// //         }} />
// //       ))}
// //     </div>
// //   );
// // }

// // /* ─── Single panel ─────────────────────────────────────────────── */
// // // On mobile: 92vw wide so the next card peeks in (scroll affordance).
// // // On desktop: 100vw wide as before.
// // function ProjectPanel({ p, index, total, isMobile }) {
// //   const panelH  = `calc(100vh - ${HEADER_H}px)`;
// //   const panelW  = isMobile ? '92vw' : '100vw';

// //   return (
// //     <div style={{
// //       width: panelW,
// //       height: panelH,
// //       flexShrink: 0,
// //       display: 'flex',
// //       alignItems: 'center',
// //       borderLeft: index > 0 ? '1px solid #111' : 'none',
// //       position: 'relative',
// //       overflow: 'hidden',
// //     }}>

// //       {/* Ghost index number — decorative */}
// //       <div aria-hidden="true" style={{
// //         position: 'absolute',
// //         top: '50%',
// //         right: '-0.04em',
// //         transform: 'translateY(-50%)',
// //         fontFamily: 'Syne, sans-serif',
// //         fontSize: isMobile ? 'clamp(28vw, 35vw, 42vw)' : 'clamp(18vw, 22vw, 28vw)',
// //         fontWeight: 800,
// //         color: p.color,
// //         opacity: 0.04,
// //         lineHeight: 1,
// //         userSelect: 'none',
// //         pointerEvents: 'none',
// //         letterSpacing: '-0.06em',
// //       }}>
// //         {String(index + 1).padStart(2, '0')}
// //       </div>

// //       {/* Left vertical accent rule */}
// //       <div style={{
// //         position: 'absolute',
// //         left: isMobile ? '5vw' : '4.5vw',
// //         top: '10%',
// //         bottom: '10%',
// //         width: '1px',
// //         background: `linear-gradient(to bottom, transparent, ${p.color}88, transparent)`,
// //       }} />

// //       {/* Content */}
// //       <div style={{
// //         position: 'relative',
// //         zIndex: 2,
// //         padding: isMobile ? '0 6vw 0 10vw' : '0 7vw 0 5vw',
// //         maxWidth: isMobile ? '88vw' : '65vw',
// //       }}>

// //         {/* Counter / type / year row */}
// //         <div style={{
// //           display: 'flex',
// //           alignItems: 'center',
// //           gap: '1.5rem',
// //           marginBottom: '1.5rem',
// //         }}>
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: isMobile ? '0.6rem' : '0.58rem',
// //             color: p.color,
// //             letterSpacing: '0.2em',
// //           }}>
// //             {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
// //           </span>
// //           <div style={{ width: 32, height: '1px', background: `${p.color}44` }} />
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: '0.55rem',
// //             color: '#3a3a3a',
// //             letterSpacing: '0.15em',
// //           }}>
// //             {(p.type || '').toUpperCase()}
// //           </span>
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: '0.55rem',
// //             color: '#252525',
// //             letterSpacing: '0.1em',
// //             marginLeft: 'auto',
// //           }}>
// //             {p.year}
// //           </span>
// //         </div>

// //         {/* Project title */}
// //         <h2 className="proj-title" style={{
// //           fontFamily: 'Syne, sans-serif',
// //           fontSize: isMobile ? 'clamp(2rem, 8vw, 3.5rem)' : 'clamp(2.4rem, 5.5vw, 6.5rem)',
// //           fontWeight: 800,
// //           letterSpacing: '-0.05em',
// //           lineHeight: 0.9,
// //           color: '#f0f0f0',
// //           marginBottom: '1.5rem',
// //         }}>
// //           {p.title}
// //         </h2>

// //         {/* Accent gradient line */}
// //         <div style={{
// //           width: isMobile ? 'min(240px, 72vw)' : 'min(380px, 42vw)',
// //           height: '1px',
// //           background: `linear-gradient(90deg, ${p.color} 0%, transparent 100%)`,
// //           marginBottom: '1.2rem',
// //         }} />

// //         {/* Description */}
// //         <p style={{
// //           fontFamily: 'Syne, sans-serif',
// //           fontSize: isMobile ? '0.82rem' : 'clamp(0.82rem, 1.1vw, 0.98rem)',
// //           color: '#565656',
// //           lineHeight: 1.78,
// //           maxWidth: isMobile ? '80vw' : 420,
// //           marginBottom: '1.5rem',
// //         }}>
// //           {p.desc}
// //         </p>

// //         {/* Tags + link */}
// //         <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
// //           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
// //             {(p.tags || []).map((t, ti) => (
// //               <span key={ti} style={{
// //                 fontFamily: 'Space Mono, monospace',
// //                 fontSize: '0.52rem',
// //                 padding: '0.22rem 0.65rem',
// //                 background: '#0c0c0c',
// //                 color: '#3a3a3a',
// //                 border: '1px solid #181818',
// //                 letterSpacing: '0.06em',
// //               }}>{t}</span>
// //             ))}
// //           </div>
// //           <a
// //             href={p.url}
// //             target="_blank"
// //             rel="noopener noreferrer"
// //             onClick={e => e.stopPropagation()}
// //             style={{
// //               fontFamily: 'Space Mono, monospace',
// //               fontSize: '0.62rem',
// //               color: p.color,
// //               letterSpacing: '0.18em',
// //               textDecoration: 'none',
// //               display: 'inline-flex',
// //               alignItems: 'center',
// //               gap: '0.55rem',
// //               transition: 'gap 0.3s cubic-bezier(0.4,0,0.2,1)',
// //             }}
// //             onMouseEnter={e => { e.currentTarget.style.gap = '1.1rem'; }}
// //             onMouseLeave={e => { e.currentTarget.style.gap = '0.55rem'; }}
// //           >
// //             VIEW PROJECT <span>→</span>
// //           </a>
// //         </div>
// //       </div>

// //       {/* Corner bracket */}
// //       <div style={{
// //         position: 'absolute',
// //         bottom: '3.5rem',
// //         right: isMobile ? '5vw' : '7vw',
// //         width: 26,
// //         height: 26,
// //         borderRight: `1px solid ${p.color}33`,
// //         borderBottom: `1px solid ${p.color}33`,
// //       }} />
// //     </div>
// //   );
// // }

// // /* ─── Main section ──────────────────────────────────────────────── */
// // export default function Projects({ loaded, isMobile }) {
// //   const [projects, setProjects]       = useState([]);
// //   const [activeIndex, setActiveIndex] = useState(0);
// //   const sectionRef = useRef(null);
// //   const trackRef   = useRef(null);

// //   useEffect(() => {
// //     fetchProjects().then(setProjects).catch(console.error);
// //   }, []);

// //   /* GSAP pin + horizontal scrub — runs on BOTH mobile and desktop */
// //   useEffect(() => {
// //     if (!loaded || projects.length === 0) return;
// //     const section = sectionRef.current;
// //     const track   = trackRef.current;
// //     if (!section || !track) return;

// //     const ctx = gsap.context(() => {
// //       const getTotal = () => track.scrollWidth - window.innerWidth;

// //       const scrollTween = gsap.to(track, {
// //         x: () => -getTotal(),
// //         ease: 'none',
// //         scrollTrigger: {
// //           trigger: section,
// //           start: 'top top',
// //           end: () => `+=${getTotal() + window.innerHeight * 0.5}`,
// //           pin: true,
// //           scrub: 0.9,
// //           anticipatePin: 1,
// //           invalidateOnRefresh: true,
// //           onUpdate(self) {
// //             const idx = Math.min(
// //               projects.length - 1,
// //               Math.round(self.progress * (projects.length - 1))
// //             );
// //             setActiveIndex(idx);
// //           },
// //         },
// //       });

// //       // Title reveal per panel (scrubbed via containerAnimation)
// //       gsap.utils.toArray('.proj-title').forEach((el) => {
// //         gsap.fromTo(el,
// //           { opacity: 0, y: 40 },
// //           {
// //             opacity: 1, y: 0,
// //             ease: 'power3.out',
// //             scrollTrigger: {
// //               trigger: el,
// //               containerAnimation: scrollTween,
// //               start: 'left 80%',
// //               end: 'left 30%',
// //               scrub: 0.5,
// //             },
// //           }
// //         );
// //       });
// //     }, section);

// //     return () => ctx.revert();
// //   }, [loaded, projects]); // ← isMobile intentionally removed from guard

// //   return (
// //     <section
// //       id="projects"
// //       ref={sectionRef}
// //       style={{
// //         background: 'var(--black)',
// //         position: 'relative',
// //         minHeight: '100vh',
// //         overflow: 'hidden',
// //         // Prevent native touch-scroll from fighting GSAP's synthetic scrub
// //         touchAction: 'pan-y',
// //       }}
// //     >
// //       {/* ══════════════════════════════════════════════════════
// //           HEADER STRIP — fixed height on all viewports.
// //          ══════════════════════════════════════════════════════ */}
// //       <div style={{
// //         position: 'absolute',
// //         top: 0, left: 0, right: 0,
// //         height: `${HEADER_H}px`,
// //         zIndex: 20,
// //         display: 'flex',
// //         alignItems: 'flex-end',
// //         justifyContent: 'space-between',
// // padding: '0 5vw 1.2rem',pointerEvents: 'none',        borderBottom: '1px solid #141414',
// //         pointerEvents: 'none',
// //         boxSizing: 'border-box',
// //       }}>
// //         <div>
// //           <Label n="02" text="Projects" />
// //           <h2 style={{
// //             fontFamily: 'Syne, sans-serif',
// //             fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)',
// //             fontWeight: 800,
// //             letterSpacing: '-0.04em',
// //             lineHeight: 0.9,
// //             margin: 0,
// //           }}>
// //             Selected <span style={{ color: 'var(--acid)' }}>Work</span>
// //           </h2>
// //         </div>

// //         {/* Active index counter — visible on all sizes */}
// //         <div style={{
// //           fontFamily: 'Space Mono, monospace',
// //           textAlign: 'right',
// //           pointerEvents: 'auto',
// //         }}>
// //           <span style={{
// //             fontSize: isMobile ? '1.6rem' : '2.4rem',
// //             fontWeight: 700,
// //             color: 'var(--acid)',
// //             display: 'block',
// //             lineHeight: 1,
// //           }}>
// //             {String(activeIndex + 1).padStart(2, '0')}
// //           </span>
// //           <span style={{
// //             fontSize: '0.55rem',
// //             color: '#252525',
// //             letterSpacing: '0.12em',
// //           }}>
// //             / {String(projects.length).padStart(2, '0')} PROJECTS
// //           </span>
// //         </div>
// //       </div>

// //       {/* ══════════════════════════════════════════════════════
// //           PROGRESS RAIL — both desktop and mobile
// //          ══════════════════════════════════════════════════════ */}
// //       <ProgressRail count={projects.length} activeIndex={activeIndex} />

// //       {/* ══════════════════════════════════════════════════════
// //           HORIZONTAL TRACK — GSAP moves this on X axis.
// //           Rendered for ALL viewports (no isMobile guard).
// //          ══════════════════════════════════════════════════════ */}
// //       <div
// //         ref={trackRef}
// //         style={{
// //           position: 'absolute',
// //           top: `${HEADER_H}px`,
// //           left: 0,
// //           display: 'flex',
// //           height: `calc(100vh - ${HEADER_H}px)`,
// //           width: 'max-content',
// //           willChange: 'transform',
// //         }}
// //       >
// //         {projects.map((p, i) => (
// //           <ProjectPanel
// //             key={i}
// //             p={p}
// //             index={i}
// //             total={projects.length}
// //             isMobile={isMobile}
// //           />
// //         ))}
// //         {/* Trailing spacer */}
// //         <div style={{ width: isMobile ? '8vw' : '5vw', flexShrink: 0 }} />
// //       </div>
// //     </section>
// //   );
// // }
// import { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { Label } from './utils';
// import { fetchProjects } from './data';

// gsap.registerPlugin(ScrollTrigger);

// const HEADER_H = 120;

// // ── Scroll budget scales with how many lines there are ──────────
// // Each line gets 2 full viewport-heights of scroll room
// const OUTRO_BUDGET_PER_LINE = 2;

// const QUOTE_LINES = [
//   'about what you add,',
//   'but what you leave out.',
//     'but what you leave out.',

// ];
// const QUOTE_ATTRIBUTION = '— Dieter Rams';

// /* ─── Progress rail ────────────────────────────────────────────── */
// function ProgressRail({ count, activeIndex }) {
//   return (
//     <div style={{
//       position: 'absolute',
//       bottom: '2rem',
//       left: '7vw',
//       right: '7vw',
//       zIndex: 30,
//       display: 'flex',
//       gap: '6px',
//       alignItems: 'center',
//       pointerEvents: 'none',
//     }}>
//       {Array.from({ length: count }).map((_, i) => (
//         <div key={i} style={{
//           flex: i === activeIndex ? 4 : 1,
//           height: '1px',
//           background: i === activeIndex ? 'var(--acid, #d4f700)' : '#222',
//           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
//         }} />
//       ))}
//     </div>
//   );
// }

// /* ─── Single panel ──────────────────────────────────────────────── */
// function ProjectPanel({ p, index, total, isMobile }) {
//   const panelH = `calc(100vh - ${HEADER_H}px)`;
//   const panelW = isMobile ? '92vw' : '100vw';

//   return (
//     <div style={{
//       width: panelW,
//       height: panelH,
//       flexShrink: 0,
//       display: 'flex',
//       alignItems: 'center',
//       borderLeft: index > 0 ? '1px solid #111' : 'none',
//       position: 'relative',
//       overflow: 'hidden',
//     }}>
//       <div aria-hidden="true" style={{
//         position: 'absolute',
//         top: '50%',
//         right: '-0.04em',
//         transform: 'translateY(-50%)',
//         fontFamily: 'Syne, sans-serif',
//         fontSize: isMobile ? 'clamp(28vw, 35vw, 42vw)' : 'clamp(18vw, 22vw, 28vw)',
//         fontWeight: 800,
//         color: p.color,
//         opacity: 0.04,
//         lineHeight: 1,
//         userSelect: 'none',
//         pointerEvents: 'none',
//         letterSpacing: '-0.06em',
//       }}>
//         {String(index + 1).padStart(2, '0')}
//       </div>

//       <div style={{
//         position: 'absolute',
//         left: isMobile ? '5vw' : '4.5vw',
//         top: '10%',
//         bottom: '10%',
//         width: '1px',
//         background: `linear-gradient(to bottom, transparent, ${p.color}88, transparent)`,
//       }} />

//       <div style={{
//         position: 'relative',
//         zIndex: 2,
//         padding: isMobile ? '0 6vw 0 10vw' : '0 7vw 0 5vw',
//         maxWidth: isMobile ? '88vw' : '65vw',
//       }}>
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: '1.5rem',
//           marginBottom: '1.5rem',
//         }}>
//           <span style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: isMobile ? '0.6rem' : '0.58rem',
//             color: p.color,
//             letterSpacing: '0.2em',
//           }}>
//             {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
//           </span>
//           <div style={{ width: 32, height: '1px', background: `${p.color}44` }} />
//           <span style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: '0.55rem',
//             color: '#3a3a3a',
//             letterSpacing: '0.15em',
//           }}>
//             {(p.type || '').toUpperCase()}
//           </span>
//           <span style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: '0.55rem',
//             color: '#252525',
//             letterSpacing: '0.1em',
//             marginLeft: 'auto',
//           }}>
//             {p.year}
//           </span>
//         </div>

//         <h2 className="proj-title" style={{
//           fontFamily: 'Syne, sans-serif',
//           fontSize: isMobile ? 'clamp(2rem, 8vw, 3.5rem)' : 'clamp(2.4rem, 5.5vw, 6.5rem)',
//           fontWeight: 800,
//           letterSpacing: '-0.05em',
//           lineHeight: 0.9,
//           color: '#f0f0f0',
//           marginBottom: '1.5rem',
//         }}>
//           {p.title}
//         </h2>

//         <div style={{
//           width: isMobile ? 'min(240px, 72vw)' : 'min(380px, 42vw)',
//           height: '1px',
//           background: `linear-gradient(90deg, ${p.color} 0%, transparent 100%)`,
//           marginBottom: '1.2rem',
//         }} />

//         <p style={{
//           fontFamily: 'Syne, sans-serif',
//           fontSize: isMobile ? '0.82rem' : 'clamp(0.82rem, 1.1vw, 0.98rem)',
//           color: '#565656',
//           lineHeight: 1.78,
//           maxWidth: isMobile ? '80vw' : 420,
//           marginBottom: '1.5rem',
//         }}>
//           {p.desc}
//         </p>

//         <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
//             {(p.tags || []).map((t, ti) => (
//               <span key={ti} style={{
//                 fontFamily: 'Space Mono, monospace',
//                 fontSize: '0.52rem',
//                 padding: '0.22rem 0.65rem',
//                 background: '#0c0c0c',
//                 color: '#3a3a3a',
//                 border: '1px solid #181818',
//                 letterSpacing: '0.06em',
//               }}>{t}</span>
//             ))}
//           </div>
//           <a
//             href={p.url}
//             target="_blank"
//             rel="noopener noreferrer"
//             onClick={e => e.stopPropagation()}
//             style={{
//               fontFamily: 'Space Mono, monospace',
//               fontSize: '0.62rem',
//               color: p.color,
//               letterSpacing: '0.18em',
//               textDecoration: 'none',
//               display: 'inline-flex',
//               alignItems: 'center',
//               gap: '0.55rem',
//               transition: 'gap 0.3s cubic-bezier(0.4,0,0.2,1)',
//             }}
//             onMouseEnter={e => { e.currentTarget.style.gap = '1.1rem'; }}
//             onMouseLeave={e => { e.currentTarget.style.gap = '0.55rem'; }}
//           >
//             VIEW PROJECT <span>→</span>
//           </a>
//         </div>
//       </div>

//       <div style={{
//         position: 'absolute',
//         bottom: '3.5rem',
//         right: isMobile ? '5vw' : '7vw',
//         width: 26,
//         height: 26,
//         borderRight: `1px solid ${p.color}33`,
//         borderBottom: `1px solid ${p.color}33`,
//       }} />
//     </div>
//   );
// }

// /* ─── Outro quote panel ─────────────────────────────────────────── */
// function OutroQuote({ isMobile }) {
//   const fontSize = isMobile
//     ? 'clamp(1.8rem, 9vw, 3.2rem)'
//     : 'clamp(3rem, 6vw, 6.5rem)';

//   return (
//     <div style={{
//       position: 'relative',
//       width: '100%',
//       height: '100%',
//       background: 'var(--black, #0a0a0a)',
//       overflow: 'hidden',
//     }}>
//       <div style={{
//         position: 'absolute',
//         inset: 0,
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}>

//         {/* ── Slot: NO fixed height, NO overflow hidden ───────────
//             Lines are absolute so they stack in the same centre
//             point. Parent is relative with enough natural height
//             from padding so nothing gets clipped.                  */}
//         <div style={{
//           position: 'relative',
//           width: '90vw',
//           /* 
//             Padding-top gives the slot a visible area that is tall
//             enough for any line even if it wraps to 2 rows.
//             We use padding instead of height so it's never too
//             small on any font-size / viewport combination.
//           */
//           paddingTop: isMobile ? '14vw' : '9vw',
//           paddingBottom: isMobile ? '14vw' : '9vw',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}>
//           {QUOTE_LINES.map((line, i) => (
//             <div
//               key={i}
//               className="proj-outro-line"
//               style={{
//                 position: 'absolute',
//                 inset: 0,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 fontFamily: 'Syne, sans-serif',
//                 fontWeight: 800,
//                 fontSize,
//                 letterSpacing: '-0.04em',
//                 lineHeight: 1.15,
//                 color: 'var(--white)',
//                 textAlign: 'center',
//                 padding: '0 2vw',
//                 /* Hard invisible so no flash before GSAP */
//                 opacity: 0,
//                 transform: 'translateY(3rem)',
//                 willChange: 'transform, opacity',
//               }}
//             >
//               {line}
//             </div>
//           ))}
//         </div>

//         {/* Attribution */}
//         <div
//           className="proj-outro-attr"
//           style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: isMobile ? '0.6rem' : '0.72rem',
//             letterSpacing: '0.22em',
//             color: 'var(--acid, #d4f700)',
//             textAlign: 'center',
//             opacity: 0,
//             transform: 'translateY(1rem)',
//             marginTop: '1rem',
//           }}
//         >
//           {QUOTE_ATTRIBUTION}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ─── Main section ──────────────────────────────────────────────── */
// export default function Projects({ loaded, isMobile }) {
//   const [projects, setProjects]       = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const sectionRef = useRef(null);
//   const trackRef   = useRef(null);

//   useEffect(() => {
//     fetchProjects().then(setProjects).catch(console.error);
//   }, []);

//   useEffect(() => {
//     if (!loaded || projects.length === 0) return;
//     const section = sectionRef.current;
//     const track   = trackRef.current;
//     if (!section || !track) return;

//     const ctx = gsap.context(() => {
//       const n = projects.length;

//       // ── Outro budget scales with line count ───────────────────
//       // More lines = more scroll room so each line gets to breathe
//       const OUTRO_BUDGET = QUOTE_LINES.length * OUTRO_BUDGET_PER_LINE;

//       const getStepH       = () => window.innerHeight - HEADER_H;
//       const getCardBudget  = () => (n - 1) * getStepH() + getStepH() * 1.2;
//       const getOutroBudget = () => getStepH() * OUTRO_BUDGET;
//       const getCertEnd     = () => getCardBudget() / (getCardBudget() + getOutroBudget());
//       const getTrackTotal  = () => track.scrollWidth - window.innerWidth;

//       // ── Kill flash frame ──────────────────────────────────────
//       const outroLines = gsap.utils.toArray('.proj-outro-line', section);
//       const outroAttr  = section.querySelector('.proj-outro-attr');

//       outroLines.forEach(el => {
//         el.style.opacity   = '0';
//         el.style.transform = 'translateY(3rem)';
//       });
//       if (outroAttr) {
//         outroAttr.style.opacity   = '0';
//         outroAttr.style.transform = 'translateY(1rem)';
//       }

//       gsap.set('.proj-outro-wrap', { clipPath: 'circle(0px at 100% 100%)', opacity: 1 });
//       gsap.set(outroLines, { opacity: 0, y: '3rem' });
//       if (outroAttr) gsap.set(outroAttr, { opacity: 0, y: '1rem' });

//       // ── Outro timeline ────────────────────────────────────────
//       const tlOutro    = gsap.timeline({ paused: true });
//       const lineCount  = outroLines.length;

//       // Phase 1 (0–0.12): circle wipe
//       tlOutro.to('.proj-outro-wrap', {
//         clipPath: 'circle(150% at 100% 100%)',
//         ease:     'power2.inOut',
//         duration: 0.12,
//       }, 0);

//       // Phase 2 (0.12–0.90): carousel
//       // Each line gets an equal slice of the phase.
//       // Within each slice: IN (30%) → HOLD (45%) → OUT (25%)
//       // Last line skips OUT and stays.
//       const phaseStart = 0.12;
//       const phaseEnd   = 0.90;
//       const slotSize   = (phaseEnd - phaseStart) / lineCount;

//       outroLines.forEach((el, i) => {
//         const s      = phaseStart + i * slotSize;   // slot start
//         const inDur  = slotSize * 0.30;
//         const hold   = slotSize * 0.45;
//         const outDur = slotSize * 0.25;

//         // IN: slide up from below + fade in
//         tlOutro.fromTo(el,
//           { opacity: 0, y: '3rem' },
//           { opacity: 1, y: '0rem', ease: 'power3.out', duration: inDur },
//           s
//         );

//         // OUT: slide up further + fade out (skip for last line)
//         if (i < lineCount - 1) {
//           tlOutro.to(el,
//             { opacity: 0, y: '-3rem', ease: 'power2.in', duration: outDur },
//             s + inDur + hold
//           );
//         }
//       });

//       // Phase 3 (0.90–1.0): attribution
//       tlOutro.fromTo('.proj-outro-attr',
//         { opacity: 0, y: '1rem' },
//         { opacity: 1, y: '0rem', ease: 'power2.out', duration: 0.10 },
//         0.90
//       );

//       // ── Horizontal track tween ────────────────────────────────
//       const tlTrack = gsap.to(track, {
//         x:    () => -getTrackTotal(),
//         ease: 'none',
//         paused: true,
//       });

//       // ── Master ScrollTrigger ──────────────────────────────────
//       ScrollTrigger.create({
//         trigger: section,
//         start:   'top top',
//         end:     () => `+=${getCardBudget() + getOutroBudget()}`,
//         pin:                 true,
//         scrub:               3,
//         anticipatePin:       1,
//         invalidateOnRefresh: true,
//         onUpdate(self) {
//           const p       = self.progress;
//           const certEnd = getCertEnd();

//           const certP = Math.min(1, p / certEnd);
//           tlTrack.progress(certP);

//           const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
//           setActiveIndex(idx);

//           const outroP = certEnd >= 1
//             ? 0
//             : Math.max(0, (p - certEnd) / (1 - certEnd));
//           tlOutro.progress(outroP);

//           const outroEl = section.querySelector('.proj-outro-wrap');
//           if (outroEl) {
//             outroEl.style.pointerEvents = outroP > 0.05 ? 'auto' : 'none';
//           }
//         },
//       });

//       gsap.set(gsap.utils.toArray('.proj-title', section), { opacity: 1, y: 0 });

//     }, section);

//     return () => ctx.revert();
//   }, [loaded, projects]);

//   return (
//     <section
//       id="projects"
//       ref={sectionRef}
//       style={{
//         background: 'var(--black)',
//         position: 'relative',
//         minHeight: '100vh',
//         overflow: 'hidden',
//         touchAction: 'pan-y',
//       }}
//     >
//       {/* HEADER STRIP */}
//       <div style={{
//         position: 'absolute',
//         top: 0, left: 0, right: 0,
//         height: `${HEADER_H}px`,
//         zIndex: 20,
//         display: 'flex',
//         alignItems: 'flex-end',
//         justifyContent: 'space-between',
//         padding: '0 5vw 1.2rem',
//         pointerEvents: 'none',
//         borderBottom: '1px solid #141414',
//         boxSizing: 'border-box',
//       }}>
//         <div>
//           <Label n="02" text="Projects" />
//           <h2 style={{
//             fontFamily: 'Syne, sans-serif',
//             fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)',
//             fontWeight: 800,
//             letterSpacing: '-0.04em',
//             lineHeight: 0.9,
//             margin: 0,
//           }}>
//             Selected <span style={{ color: 'var(--acid)' }}>Work</span>
//           </h2>
//         </div>

//         <div style={{
//           fontFamily: 'Space Mono, monospace',
//           textAlign: 'right',
//           pointerEvents: 'auto',
//         }}>
//           <span style={{
//             fontSize: isMobile ? '1.6rem' : '2.4rem',
//             fontWeight: 700,
//             color: 'var(--acid)',
//             display: 'block',
//             lineHeight: 1,
//           }}>
//             {String(activeIndex + 1).padStart(2, '0')}
//           </span>
//           <span style={{
//             fontSize: '0.55rem',
//             color: '#252525',
//             letterSpacing: '0.12em',
//           }}>
//             / {String(projects.length).padStart(2, '0')} PROJECTS
//           </span>
//         </div>
//       </div>

//       {/* PROGRESS RAIL */}
//       <ProgressRail count={projects.length} activeIndex={activeIndex} />

//       {/* HORIZONTAL TRACK */}
//       <div
//         ref={trackRef}
//         style={{
//           position: 'absolute',
//           top: `${HEADER_H}px`,
//           left: 0,
//           display: 'flex',
//           height: `calc(100vh - ${HEADER_H}px)`,
//           width: 'max-content',
//           willChange: 'transform',
//         }}
//       >
//         {projects.map((p, i) => (
//           <ProjectPanel
//             key={i}
//             p={p}
//             index={i}
//             total={projects.length}
//             isMobile={isMobile}
//           />
//         ))}
//         <div style={{ width: isMobile ? '8vw' : '5vw', flexShrink: 0 }} />
//       </div>

//       {/* OUTRO OVERLAY */}
//       <div
//         className="proj-outro-wrap"
//         style={{
//           position: 'absolute',
//           top: 0, left: 0,
//           width: '100%', height: '100%',
//           zIndex: 40,
//           overflow: 'hidden',
//           background: 'var(--black)',
//           pointerEvents: 'none',
//         }}
//       >
//         <OutroQuote isMobile={isMobile} />
//       </div>
//     </section>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Label } from './utils';
import { fetchProjects, fetchProjectsQuote } from './data';

gsap.registerPlugin(ScrollTrigger);

const HEADER_H = 120;

// ── Scroll budget scales with how many lines there are ──────────
// Each line gets 2 full viewport-heights of scroll room
const OUTRO_BUDGET_PER_LINE = 1.5;

// ── Fallback shown while Firestore quote loads ──────────────────
const FALLBACK_QUOTE = {
  lines:       ['about what you add,', 'but what you leave out.'],
  attribution: '',
};

/* ─── Progress rail ────────────────────────────────────────────── */
function ProgressRail({ count, activeIndex }) {
  return (
    <div 

    style={{
      position: 'absolute',
      bottom: '2rem',
      left: '7vw',
      right: '7vw',
      zIndex: 30,
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      pointerEvents: 'none',
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{
          flex: i === activeIndex ? 4 : 1,
          height: '1px',
          background: i === activeIndex ? 'var(--acid, #d4f700)' : '#222',
          transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
        }} />
      ))}
    </div>
  );
}

/* ─── Single panel ──────────────────────────────────────────────── */
function ProjectPanel({ p, index, total, isMobile }) {
  const panelH = `calc(100vh - ${HEADER_H}px)`;
  const panelW = isMobile ? '92vw' : '100vw';

  return (
    <div style={{
      width: panelW,
      height: panelH,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      borderLeft: index > 0 ? '1px solid var(--border)' : 'none',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div aria-hidden="true" style={{
        position: 'absolute',
        top: '50%',
        right: '-0.04em',
        transform: 'translateY(-50%)',
        fontFamily: 'Syne, sans-serif',
        fontSize: isMobile ? 'clamp(28vw, 35vw, 42vw)' : 'clamp(18vw, 22vw, 28vw)',
        fontWeight: 800,
        color: p.color,
        opacity: 0.04,
        lineHeight: 1,
        userSelect: 'none',
        pointerEvents: 'none',
        letterSpacing: '-0.06em',
      }}>
        {String(index + 1).padStart(2, '0')}
      </div>

      <div style={{
        position: 'absolute',
        left: isMobile ? '5vw' : '4.5vw',
        top: '10%',
        bottom: '10%',
        width: '1px',
        background: `linear-gradient(to bottom, transparent, ${p.color}88, transparent)`,
      }} />

      <div style={{
        position: 'relative',
        zIndex: 2,
        padding: isMobile ? '0 6vw 0 10vw' : '0 7vw 0 5vw',
        maxWidth: isMobile ? '88vw' : '65vw',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1.5rem',
          marginBottom: '1.5rem',
        }}>
          <span style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: isMobile ? '0.6rem' : '0.58rem',
            color: p.color,
            letterSpacing: '0.2em',
          }}>
            {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
          </span>
          <div style={{ width: 32, height: '1px', background: `${p.color}44` }} />
          <span style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: '0.55rem',
            color: 'var(--muted)',
            letterSpacing: '0.15em',
          }}>
            {(p.type || '').toUpperCase()}
          </span>
          <span style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: '0.55rem',
            color: 'var(--muted)',
            letterSpacing: '0.1em',
            marginLeft: 'auto',
          }}>
            {p.year}
          </span>
        </div>

        <h2 className="proj-title" style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: isMobile ? 'clamp(2rem, 8vw, 3.5rem)' : 'clamp(2.4rem, 5.5vw, 6.5rem)',
          fontWeight: 800,
          letterSpacing: '-0.05em',
          lineHeight: 0.9,
          color: 'var(--white)',
          marginBottom: '1.5rem',
        }}>
          {p.title}
        </h2>

        <div style={{
          width: isMobile ? 'min(240px, 72vw)' : 'min(380px, 42vw)',
          height: '1px',
          background: `linear-gradient(90deg, ${p.color} 0%, transparent 100%)`,
          marginBottom: '1.2rem',
        }} />

        <p style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: isMobile ? '0.82rem' : 'clamp(0.82rem, 1.1vw, 0.98rem)',
          color: 'var(--white)',
          lineHeight: 1.78,
          maxWidth: isMobile ? '80vw' : 420,
          marginBottom: '1.5rem',
        }}>
          {p.desc}
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
            {(p.tags || []).map((t, ti) => (
              <span key={ti} style={{
                fontFamily: 'Space Mono, monospace',
                fontSize: '0.52rem',
                padding: '0.22rem 0.65rem',
                background: `${p.color}0a`,
                color: 'var(--white)',
                border: `1px solid ${p.color}22`,
                letterSpacing: '0.06em',
              }}>{t}</span>
            ))}
          </div>
          <a
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            style={{
              fontFamily: 'Space Mono, monospace',
              fontSize: '0.62rem',
              color: p.color,
              letterSpacing: '0.18em',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.55rem',
              transition: 'gap 0.3s cubic-bezier(0.4,0,0.2,1)',
            }}
            onMouseEnter={e => { e.currentTarget.style.gap = '1.1rem'; }}
            onMouseLeave={e => { e.currentTarget.style.gap = '0.55rem'; }}
          >
            VIEW PROJECT <span>→</span>
          </a>
        </div>
      </div>

      <div style={{
        position: 'absolute',
        bottom: '3.5rem',
        right: isMobile ? '5vw' : '7vw',
        width: 26,
        height: 26,
        borderRight: `1px solid ${p.color}33`,
        borderBottom: `1px solid ${p.color}33`,
      }} />
    </div>
  );
}

/* ─── Outro quote panel ─────────────────────────────────────────── */
function OutroQuote({ isMobile, quoteLines, quoteAttribution }) {
  const fontSize = isMobile
    ? 'clamp(1.8rem, 9vw, 3.2rem)'
    : 'clamp(3rem, 6vw, 6.5rem)';

  return (
    <div
                           data-cursor-text="Scroll
 down"     


    style={{
      position: 'relative',
      width: '100%',
      height: '100%',
      background: 'var(--black, #0a0a0a)',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {/* ── Slot: NO fixed height, NO overflow hidden ─────────── */}
        <div style={{
          position: 'relative',
          width: '90vw',
          paddingTop: isMobile ? '14vw' : '9vw',
          paddingBottom: isMobile ? '14vw' : '9vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {quoteLines.map((line, i) => (
            <div
              key={i}
              className="proj-outro-line"
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Syne, sans-serif',
                fontWeight: 800,
                fontSize,
                letterSpacing: '-0.04em',
                lineHeight: 1.15,
                color: 'var(--white)',
                textAlign: 'center',
                padding: '0 2vw',
                opacity: 0,
                transform: 'translateY(3rem)',
                willChange: 'transform, opacity',
              }}
            >
              {line}
            </div>
          ))}
        </div>

        {/* Attribution */}
        <div
          className="proj-outro-attr"
          style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: isMobile ? '0.6rem' : '0.72rem',
            letterSpacing: '0.22em',
            color: 'var(--acid, #d4f700)',
            textAlign: 'center',
            opacity: 0,
            transform: 'translateY(1rem)',
            marginTop: '1rem',
          }}
        >
          {quoteAttribution}
        </div>
      </div>
    </div>
  );
}

/* ─── Main section ──────────────────────────────────────────────── */
export default function Projects({ loaded, isMobile }) {
  const [projects, setProjects]       = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  // ── Dynamic quote state ───────────────────────────────────────
  const [quoteLines, setQuoteLines]           = useState(FALLBACK_QUOTE.lines);
  const [quoteAttribution, setQuoteAttribution] = useState(FALLBACK_QUOTE.attribution);
  const [quoteReady, setQuoteReady]           = useState(false);

  const sectionRef = useRef(null);
  const trackRef   = useRef(null);

  // ── Fetch projects ────────────────────────────────────────────
  useEffect(() => {
    fetchProjects().then(setProjects).catch(console.error);
  }, []);

  // ── Fetch quote from Firestore ────────────────────────────────
  useEffect(() => {
    fetchProjectsQuote()
      .then(({ lines, attribution }) => {
        setQuoteLines(lines);
        setQuoteAttribution(attribution);
      })
      .catch(() => {
        // silently keep fallback
      })
      .finally(() => setQuoteReady(true));
  }, []);

  // ── GSAP setup — waits for both projects AND quote to be ready ─
  useEffect(() => {
    if (!loaded || projects.length === 0 || !quoteReady) return;
    const section = sectionRef.current;
    const track   = trackRef.current;
    if (!section || !track) return;

    const ctx = gsap.context(() => {
      const n = projects.length;

      // ── Outro budget scales with line count ───────────────────
      const OUTRO_BUDGET = quoteLines.length * OUTRO_BUDGET_PER_LINE;

      const getStepH       = () => window.innerHeight - HEADER_H;
      const getCardBudget  = () => (n - 1) * getStepH() + getStepH() * 1.2;
      const getOutroBudget = () => getStepH() * OUTRO_BUDGET;
      const getCertEnd     = () => getCardBudget() / (getCardBudget() + getOutroBudget());
      const getTrackTotal  = () => track.scrollWidth - window.innerWidth;

      // ── Kill flash frame ──────────────────────────────────────
      const outroLines = gsap.utils.toArray('.proj-outro-line', section);
      const outroAttr  = section.querySelector('.proj-outro-attr');

      outroLines.forEach(el => {
        el.style.opacity   = '0';
        el.style.transform = 'translateY(3rem)';
      });
      if (outroAttr) {
        outroAttr.style.opacity   = '0';
        outroAttr.style.transform = 'translateY(1rem)';
      }

      gsap.set('.proj-outro-wrap', { clipPath: 'circle(0px at 100% 0%)', opacity: 1 });
      gsap.set(outroLines, { opacity: 0, y: '3rem' });
      if (outroAttr) gsap.set(outroAttr, { opacity: 0, y: '1rem' });

      // ── Outro timeline ────────────────────────────────────────
      const tlOutro   = gsap.timeline({ paused: true });
      const lineCount = outroLines.length;

      // Phase 1 (0–0.12): circle wipe
      tlOutro.to('.proj-outro-wrap', {
        clipPath: 'circle(150% at 100% 0%)',
        ease:     'power2.inOut',
        duration: 0.12,
      }, 0);

      // Phase 2 (0.12–0.90): carousel
      const phaseStart = 0.12;
      const phaseEnd   = 0.90;
      const slotSize   = (phaseEnd - phaseStart) / lineCount;

      outroLines.forEach((el, i) => {
        const s      = phaseStart + i * slotSize;
        const inDur  = slotSize * 0.30;
        const hold   = slotSize * 0.45;
        const outDur = slotSize * 0.25;

        tlOutro.fromTo(el,
          { opacity: 0, y: '3rem' },
          { opacity: 1, y: '0rem', ease: 'power3.out', duration: inDur },
          s
        );

        if (i < lineCount - 1) {
          tlOutro.to(el,
            { opacity: 0, y: '-3rem', ease: 'power2.in', duration: outDur },
            s + inDur + hold
          );
        }
      });

      // Phase 3 (0.90–1.0): attribution
      tlOutro.fromTo('.proj-outro-attr',
        { opacity: 0, y: '1rem' },
        { opacity: 1, y: '0rem', ease: 'power2.out', duration: 0.10 },
        0.90
      );

      // ── Horizontal track tween ────────────────────────────────
      const tlTrack = gsap.to(track, {
        x:    () => -getTrackTotal(),
        ease: 'none',
        paused: true,
      });

      // ── Master ScrollTrigger ──────────────────────────────────
      ScrollTrigger.create({
        trigger: section,
        start:   'top top',
        end:     () => `+=${getCardBudget() + getOutroBudget()}`,
        pin:                 true,
        scrub:               1,
        anticipatePin:       1,
        invalidateOnRefresh: true,
        onUpdate(self) {
          const p       = self.progress;
          const certEnd = getCertEnd();

          const certP = Math.min(1, p / certEnd);
          tlTrack.progress(certP);

          const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
          setActiveIndex(idx);

          const outroP = certEnd >= 1
            ? 0
            : Math.max(0, (p - certEnd) / (1 - certEnd));
          tlOutro.progress(outroP);

          const outroEl = section.querySelector('.proj-outro-wrap');
          if (outroEl) {
            outroEl.style.pointerEvents = outroP > 0.05 ? 'auto' : 'none';
          }
        },
      });

      gsap.set(gsap.utils.toArray('.proj-title', section), { opacity: 1, y: 0 });

    }, section);

    return () => ctx.revert();
  }, [loaded, projects, quoteReady, quoteLines]);

  return (
    <section
      id="projects"
      ref={sectionRef}
      style={{
        background: 'var(--black)',
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        touchAction: 'pan-y',
      }}
    >
      {/* HEADER STRIP */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: `${HEADER_H}px`,
        zIndex: 20,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        padding: '0 5vw 1.2rem',
        pointerEvents: 'none',
        borderBottom: '1px solid var(--border)',
        boxSizing: 'border-box',
      }}>
        <div>
          <Label n="03" text="Projects" />
          <h2 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 0.9,
            margin: 0,
          }}>
            Selected <span style={{ color: 'var(--acid)' }}>Work</span>
          </h2>
        </div>

        <div style={{
          fontFamily: 'Space Mono, monospace',
          textAlign: 'right',
          pointerEvents: 'auto',
        }}>
          <span style={{
            fontSize: isMobile ? '1.6rem' : '2.4rem',
            fontWeight: 700,
            color: 'var(--acid)',
            display: 'block',
            lineHeight: 1,
          }}>
            {String(activeIndex + 1).padStart(2, '0')}
          </span>
          <span style={{
            fontSize: '0.55rem',
            color: 'var(--muted)',
            letterSpacing: '0.12em',
          }}>
            / {String(projects.length).padStart(2, '0')} PROJECTS
          </span>
        </div>
      </div>

      {/* PROGRESS RAIL */}
      <ProgressRail count={projects.length} activeIndex={activeIndex} />

      {/* HORIZONTAL TRACK */}
      <div
        ref={trackRef}
        style={{
          position: 'absolute',
          top: `${HEADER_H}px`,
          left: 0,
          display: 'flex',
          height: `calc(100vh - ${HEADER_H}px)`,
          width: 'max-content',
          willChange: 'transform',
        }}
      >
        {projects.map((p, i) => (
          <ProjectPanel
            key={i}
            p={p}
            index={i}
            total={projects.length}
            isMobile={isMobile}
          />
        ))}
        <div style={{ width: isMobile ? '8vw' : '5vw', flexShrink: 0 }} />
      </div>

      {/* OUTRO OVERLAY */}
      <div
        className="proj-outro-wrap"
        style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%', height: '100%',
          zIndex: 40,
          overflow: 'hidden',
          background: 'var(--black)',
          pointerEvents: 'none',
        }}
      >
        <OutroQuote
          isMobile={isMobile}
          quoteLines={quoteLines}
          quoteAttribution={quoteAttribution}
        />
      </div>
    </section>
  );
}